import { countryCodeToCurrency } from "./countryCodeToCurrency";

import { CurrencyUtils } from "@indeed/frontend-i18n-utils";

export const getLocaleCurrency = (locale: string) => {
  try {
    const country = locale.match(/\w\w$/)?.[0] ?? "US";
    const currencyCode =
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
      countryCodeToCurrency[country as keyof typeof countryCodeToCurrency] ?? "USD";
    const currencySymbol = CurrencyUtils.formatCurrency({
      amount: 0,
      showDecimalPlaces: false,
      currency: currencyCode,
      locale,
    }).replace("0", "");
    const isSymbolAfter = CurrencyUtils.getIsSymbolAfter(locale);

    return {
      hasRighthandSymbol: typeof isSymbolAfter === "boolean" && isSymbolAfter,
      currencySymbol,
      currencyCode,
    };
  } catch {
    // invalid locale
    return {
      hasRighthandSymbol: false,
      currencySymbol: "$",
      currencyCode: countryCodeToCurrency.US,
    };
  }
};
